import {styled} from "@mui/material";

export const OverflowSkillsList = styled('div')({
  '&::-webkit-scrollbar': {
    display: 'none',
    width: 0
  },
});
